// The Preview's top bar Refresh: a ready preview only reloads its iframe (no restart, no pull of the source from
// vfs-service). A full re-render (/api/render) stays for Shift+click (clean install) and for a preview that is not
// ready: no address yet, still loading, failed or stopped.
export function canReloadInPlace(tab, { forceClean = false } = {}) {
  if (forceClean || !tab) { return false; }
  return Boolean(tab.url) && !tab.loading && !tab.error && !tab.stopped && !tab.starting;
}
